import { Map } from 'immutable'
import { FRONT, RIGHT, LEFT, SET_WALKING_DIRECTION, SET_ENTRY_POINT } from './navigationActions'

const INITIAL_STATE = Map({
    orientation: FRONT,
    walkingDirection: null,
    entryPoint: null,
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FRONT:
        case RIGHT:
        case LEFT:
            return state.set('orientation', action.type)
        case SET_WALKING_DIRECTION:
            return state.set('walkingDirection', action.walkingDirection)
        case SET_ENTRY_POINT:
            return state.set('entryPoint', action.entryPoint)
        default:
            return state
    }
}
